(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shampoo-first-lp"] && !Shopify.designMode) return;
  try {
    
// GTMで後からinsertされる ad-coupon-banner-v* を検知して即削除
(function(){
  function purge() {
    document.querySelectorAll('[id^="ad-coupon-banner"], [class*="ad-coupon-banner"]').forEach(function(el){
      try { el.remove(); } catch(e){}
    });
  }
  purge();
  if (document.readyState !== 'loading') {
    setTimeout(purge, 200); setTimeout(purge, 800); setTimeout(purge, 2000);
  } else {
    document.addEventListener('DOMContentLoaded', function(){ purge(); setTimeout(purge, 800); setTimeout(purge, 2000); });
  }
  // 動的挿入監視
  if (window.MutationObserver) {
    new MutationObserver(purge).observe(document.documentElement, {childList: true, subtree: true});
  }
})();

(function(){
  try {
    var params = new URLSearchParams(window.location.search);
    // 広告特有のパラメータだけで判定（オーガニック投稿からの訪問は除外）
    var isAd = (
      params.get('utm_medium') === 'paid' ||
      params.get('utm_medium') === 'cpc' ||
      params.get('utm_source') === 'ig' ||
      params.get('utm_source') === 'fb' ||
      params.get('utm_source') === 'instagram' ||
      params.get('utm_source') === 'facebook' ||
      params.has('fbclid') ||
      params.has('gclid') ||
      (params.get('utm_campaign') || '').indexOf('shampoo_first') === 0
    );
    if (isAd) { try { sessionStorage.setItem('sf_ad_traffic','1'); } catch(e){} }
    var remembered = false;
    try { remembered = sessionStorage.getItem('sf_ad_traffic') === '1'; } catch(e){}
    if (isAd || remembered) {
      document.body.classList.add('sf-ad-traffic');
    }
  } catch(e){}
})();


  (function() {
    var lp = document.getElementById('sf-lp');
    if (!lp) return;

    // Sticky CTA - move to document.body to avoid any ancestor containing-block issues
    var sticky = document.getElementById('sf-sticky');
    if (sticky && sticky.parentNode !== document.body) {
      document.body.appendChild(sticky);
    }
    // Reserve bottom space so sticky never overlaps page bottom (footer links, etc.)
    function applyStickyPadding() {
      if (!sticky) return;
      var h = sticky.getBoundingClientRect().height || 96;
      document.body.style.paddingBottom = (h + 16) + 'px';
    }
    if (sticky) {
      // Apply once loaded (poster frames may shift size)
      window.addEventListener('load', applyStickyPadding);
      applyStickyPadding();
      // Re-apply on resize (mobile browser chrome toggle)
      window.addEventListener('resize', applyStickyPadding);
    }
    var s1 = lp.querySelector('.sf-s1');
    if (sticky && s1) {
      var observer = new IntersectionObserver(function(entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(s1);
    }

    // CTA click tracking
    lp.querySelectorAll('[data-cta]').forEach(function(el) {
      el.addEventListener('click', function() {
        var loc = el.getAttribute('data-cta');
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'sf_lp_cta_click',
            cta_location: loc,
            coupon_code: 'SELF1000',
          });
        }
        // Meta Pixel AddPaymentInfo? no - we just track click
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'LPCTAClick', { location: loc });
        }
      });
    });

    // Instagram in-app browser detection + external browser suggestion
    var ua = navigator.userAgent || '';
    var isIGAB = /Instagram/i.test(ua) || /FBAN|FBAV/i.test(ua);
    if (isIGAB) {
      // Add suggestion banner
      var banner = document.createElement('div');
      banner.className = 'sf-igab-hint';
      banner.innerHTML = '<span>決済に進めない場合は右上「…」から<br>「外部ブラウザで開く」をお試しください</span>';
      banner.style.cssText = 'position:fixed;top:env(safe-area-inset-top);left:0;right:0;z-index:99;background:#1F1915;color:#E8D28A;padding:8px 16px;font-size:11px;text-align:center;line-height:1.6;letter-spacing:0.04em;border-bottom:1px solid rgba(212,175,55,.5);';
      document.body.insertBefore(banner, document.body.firstChild);
      setTimeout(function() {
        banner.style.transition = 'opacity .6s';
        banner.style.opacity = '0';
        setTimeout(function() { banner.remove(); }, 700);
      }, 8000);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
